import { PayloadAction } from '@reduxjs/toolkit';
import { defaultInternalState } from '@ui/features/quote-builder/state/utilities/default-state';
import { updateQuoteData } from '@ui/features/quote-builder/state/utilities/update-quote-data';

import { ExtraReducerBuilder } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { editSnapQuote } from '../endpoints/edit-snap-quote';
import { transformSnapQuoteToStoreState } from '../utilities/transform-quote';

function editSnapQuoteFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof editSnapQuote.Types.ResultType>,
) {
  // Assign the defaults first so that we can populate the Issues
  Object.assign(state, defaultInternalState);

  const { quote } = transformSnapQuoteToStoreState(action.payload);

  updateQuoteData(state, quote);
}

export function editSnapQuoteReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(editSnapQuote.matchFulfilled, editSnapQuoteFulfilled);
}
